import React, { useEffect } from 'react';
import PreacrisForm from './PreacrisForm';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from 'store';
import { PREACRIS_ONLINE_FORM, LocationFormNames } from './Preacris.constants';
import { getFormValues } from 'redux-form';
import { loadingSelector, ReducerNames } from 'common';
import {
  usStateSelector,
  valueSelector,
  driversSelector,
  xdetailsSelector,
} from './Preacris.selectors';
import { getStates, getLicenseFlag } from './Preacris.actions';
import { useAccount, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { getAccessToken } from 'common/helpers';
import { AzureAdClaims } from 'common/models';

const Preacris: React.FC = () => {
  const dispatch = useDispatch();

  const {
    loading,
    formValues,
    usStates,
    stateHob,
    countyHob,
    cmtdocId,
    driversData,
    xdetailsData,
  } = useSelector((state: AppState) => ({
    loading: loadingSelector(ReducerNames.PREACRIS)(state),
    formValues: getFormValues(PREACRIS_ONLINE_FORM)(state),
    usStates: usStateSelector(state),
    stateHob: valueSelector(state, LocationFormNames.STATE),
    countyHob: valueSelector(state, LocationFormNames.COUNTY),
    cmtdocId: valueSelector(state, LocationFormNames.CMT),
    driversData: driversSelector(state),
    xdetailsData: xdetailsSelector(state),
  }));

  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});

  useEffect(() => {
    if (account && inProgress === InteractionStatus.None) {
      getAccessToken(instance, account, inProgress).then((response) => {
        if (response?.accessToken && response?.idTokenClaims) {
          const azureAdClaims = response.idTokenClaims as AzureAdClaims;
          // TODO technically this isn't the right username since it's not the one that's in our database,
          // but this controller method in the API currently always returns true and doesn't check the username at all
          dispatch(
            getLicenseFlag(azureAdClaims.UserName, response.accessToken),
          );
        }
      });
    }
  }, [dispatch, instance, account, inProgress]);

  useEffect(() => {
    if (account && inProgress === InteractionStatus.None && !usStates) {
      getAccessToken(instance, account, inProgress).then((response) => {
        if (response?.accessToken) dispatch(getStates(response.accessToken));
      });
    }
  }, [dispatch, usStates]);

  return (
    <PreacrisForm
      {...{
        usStates,
        loading,
        formValues,
        workaround: true,
        stateHob,
        countyHob,
        cmtdocId,
        driversData,
        xdetailsData,
      }}
    />
  );
};

export default Preacris;
